import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { useFeatureFlags } from "./useFeatureFlags";
import { useJoinRequests } from "./useJoinRequests";
import { useUsers } from "./useUsers";
import { filterActionableJoinRequests } from "../utils/joinRequestUtils";

/**
 * Count of join requests that still need school action (shared by sidebar + dashboard).
 * Returns 0 without fetching for anyone who can't open User Management — same
 * access rule as its sidebar item: feature flag on, approved, and an org admin
 * or team Admin.
 */
export function usePendingJoinRequestCount() {
  const { user } = useAuth();
  const { isUserManagementEnabled } = useFeatureFlags();
  const isTeam = user?.userType === "team";
  const enabled =
    isUserManagementEnabled &&
    (isTeam ? user?.accessLevel === "Admin" : Boolean(user?.isSchoolApproved));

  const { data: joinRequests = [] } = useJoinRequests({ enabled });
  const { data: users = [] } = useUsers({ enabled });

  return useMemo(() => {
    if (!enabled) return 0;
    return filterActionableJoinRequests(joinRequests, users).length;
  }, [enabled, joinRequests, users]);
}
